<template>
  <div class="modal modal-filter-details fade" :id="'modal-edit-due-date' + '' + paymentId" role="dialog" aria-labelledby="location-label" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="location-label">Edit Payment Due Date</h4>
        </div>
        <div class="modal-body col-xs-12">
          <div class="col-sm-4 col-sm-offset-4">
            <flatpickr
              :id="paymentId"
              :key="paymentId"
              v-model="selectedDate"
              :config="flatPickerSingleDateConfig"
              class="form-control pickdate"
              placeholder="Please select a date"
              name="date"></flatpickr>
            <p v-if="previous !== selectedDate">Previously {{ previous | date($user.date_format_preference) }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" data-dismiss="modal" @click="handleSaveDueDateCallback">Save</button>
          <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-close"></i> Close Without Saving</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flatpickr from 'vue-flatpickr-component'
import moment from 'moment-timezone'

export default {
  components: { Flatpickr },

  props: {
    paymentId: {
      type: Number,
      required: true
    },
    paymentDueDate: {
      type: String,
      required: true
    },
    updatePayment: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      flatPickerSingleDateConfig: {
        altInput: true,
        wrap: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d'
      },
      previous: moment(this.paymentDueDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      selectedDate: moment(this.paymentDueDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    }
  },

  methods: {
    handleSaveDueDateCallback () {
      return this.updatePayment({ id: this.paymentId, payload: { due_date: this.selectedDate } })
    }
  }
}
</script>
